import React, { useEffect, useState } from 'react';
import VarRevInsDetailPresentational from './VarRevInsDetailPresentational';
import { useLoading } from '../../../commons/Loading';
import { useAuth } from '../../../commons/Auth';
import { useTranslation } from 'react-i18next';
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params';
import {
  createBonus,
  createBonusCommercial,
  getReportsVariableRevenuesInsurances,
  getReportsVariableRevenuesInsurancesNetwork,
} from '../../../lib/fetch/reports';
import { useDebouncedCallback } from 'use-debounce';
import { useAlert } from 'react-alert';

const VarRevInsDetail = (props) => {
  const { profile = {} } = props;

  const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;
  const { _id: profileId } = profile;
  const { showLoading, hideLoading } = useLoading();
  const [{ newToken } = {}] = useAuth();
  const alert = useAlert();
  const [t] = useTranslation('CONTACTS');
  const [reports, setReports] = useState({
    categories: { gnet_admin: {}, supplier: {}, bonuses: { data: [] } },
    totals: {},
  });

  const [total, setTotal] = useState(0);

  const [query, setQuery] = useQueryParams({
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    offset: NumberParam,
    year: withDefault(NumberParam, new Date().getFullYear()),
    insuranceNumber: withDefault(StringParam, ''),
    insuranceAdmin: withDefault(StringParam, ''),
    insuranceSupplier: withDefault(StringParam, ''),
    subAdminsInvoicesNumber: withDefault(StringParam, ''),
    insuranceAccountabilityYear: NumberParam,
    insuranceAccountabilityMonth: NumberParam,
  });

  const {
    limit,
    offset,
    year,
    insuranceNumber,
    insuranceAdmin,
    insuranceSupplier,
    insuranceAccountabilityYear,
    insuranceAccountabilityMonth,
    search,
  } = query;

  const [fetchReportsInsurances] = useDebouncedCallback(async () => {
    showLoading();
    const response = await getReportsVariableRevenuesInsurancesNetwork({
      limit,
      offset,
      year,
      insuranceNumber,
      insuranceAdmin,
      insuranceSupplier,
      insuranceAccountabilityYear,
      insuranceAccountabilityMonth,
      search,
      newToken,
      profileId,
    });

    hideLoading();

    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    const { data = [] } = response;
    setReports(data);
    setTotal(data.categories?.variableRevenuesInsurances?.count);
  }, 1000);

  useEffect(() => {
    fetchReportsInsurances();
  }, [
    limit,
    offset,
    year,
    insuranceNumber,
    insuranceAdmin,
    insuranceSupplier,
    insuranceAccountabilityYear,
    insuranceAccountabilityMonth,
    search,
  ]);

  function onFilter(queryDiff) {
    if (
      (queryDiff.insuranceAccountabilityYear &&
        queryDiff.insuranceAccountabilityYear !==
          insuranceAccountabilityYear) ||
      queryDiff.insuranceAccountabilityYear === ''
    ) {
      queryDiff.insuranceAccountabilityMonth = '';
    }

    if (queryDiff.limit && queryDiff.limit !== limit) {
      queryDiff.offset = 0;
    }
    setQuery(queryDiff);
  }

  async function onAddCommercialBonus(bonus) {
    const { error } = await createBonusCommercial({
      newToken,
      bonus: { ...bonus, profileId },
    });

    if (error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    fetchReportsInsurances();
    alert.success(t('COMMON:SUCCESS_CREATE'));
  }

  return (
    <VarRevInsDetailPresentational
      data={reports}
      onAddCommercialBonus={onAddCommercialBonus}
      onFilter={onFilter}
      query={query}
      total={total}
      profileType={profile.type}
      {...props}
    />
  );
};

export default VarRevInsDetail;
